import { render, staticRenderFns } from "./TournamentDisciplinesPanels.vue?vue&type=template&id=e3f08154&scoped=true&"
import script from "./TournamentDisciplinesPanels.vue?vue&type=script&lang=js&"
export * from "./TournamentDisciplinesPanels.vue?vue&type=script&lang=js&"
import style0 from "./TournamentDisciplinesPanels.vue?vue&type=style&index=0&id=e3f08154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f08154",
  null
  
)

export default component.exports